import { ECategory } from '../../../types/share';
import { TDealType } from '../../../types/charts';

export function getDealTypeForChart(category: ECategory): TDealType {
  if (category.toLowerCase().includes('daily')) {
    return 'rentDay';
  }

  return category.toLowerCase().includes('rent') ? 'rent' : 'sale';
}
